import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header group={null} version={null} />
      <div style={{ backgroundColor: "#fff", minHeight: "100vh", padding: "40px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ marginBottom: "30px" }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                color: "#007bff",
                textDecoration: "underline",
                marginBottom: "20px",
              }}
            >
              ← Back
            </button>
            <h1 className="mission_heading" style={{ marginBottom: "30px", textAlign: "left" }}>
              Privacy Policy
            </h1>
          </div>

          <div>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px" }}>
            SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            When you sign up to our website we collect the personal
            information you give such as your name, email address. And when
            you register to our services we collect some more personal
            information such as:
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            Full name ,Email Address ,Date of birth ,Phone number
            ,Occupation ,Your current and permanent address,Document of ID
            Proof ,Document of 10th grade marks card ,Document of degree
            certificate ,Your photo
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>Information Use</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            The information collected by our website is used for the purpose
            it is intended and to provide specific and better services to
            individuals. As applicable, the information you provide to us
            may be used to:ide to us may be used to:
          </p>
          <ul>
                <li style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginLeft: "40px", marginBottom: "10px" }}>
              Contact you for Events, Training and other specific updates
            </li>
                <li style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginLeft: "40px", marginBottom: "10px" }}>
              Contact you for membership status
            </li>
                <li style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginLeft: "40px", marginBottom: "10px" }}>
              Contact you for the programs that you are associated with us
              for
            </li>
                <li style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginLeft: "40px", marginBottom: "10px" }}>
              Update you on studies, papers, articles and surveys carried
              out by HEARTFUL TECH PVT LTD.
            </li>
                <li style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginLeft: "40px", marginBottom: "10px" }}>
              Monitor or improve the use of HEARTFUL TECH PVT LTD. website
            </li>
                <li style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginLeft: "40px", marginBottom: "10px" }}>
              Monitor compliance with our Site privacy policy
            </li>
                <li style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginLeft: "40px", marginBottom: "10px" }}>
              Provide special information materials to you from us and/or
              our respective affiliates, subsidiaries and other third
              parties
            </li>
                <li style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginLeft: "40px", marginBottom: "10px" }}>
              For aggregating information such as demographics and Site
              usage statistics
            </li>
          </ul>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            Our website reserves the right to share your information with
            organizations affiliated with HEARTFUL TECH PVT LTD. without
            your permission. Collected information will not be sold,
            exchanged, transferred or given to any other company for any
            reason whatsoever without your consent, other than the
            exceptions like required by law, search warrants, other court
            orders or national exigent circumstances
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>SECTION 2 - CONSENT</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>How do you get my consent?</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            When you provide us with personal information to complete a
            transaction, verify your credit card, place an order, arrange
            for a delivery or return a purchase, we imply that you consent
            to our collecting it and using it for that specific reason only.
            If we ask for your personal information for a secondary reason,
            like marketing, we will either ask you directly for your
            expressed consent, or provide you with an opportunity to say no.
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>How do I withdraw my consent?</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            If after you opt-in, if you change your mind, you may withdraw
            your consent for us to contact you, for the continued
            collection, use or disclosure of your information, at anytime,
            by contacting us at hello@heartfultech.com or mailing us at: H
            No.13-14, 2nd floor, Kothnur Main Rd, Opposite Corporation Bank,
            JP Nagar 7th Phase, Bengaluru, Karnataka - 560078.
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>SECTION 3 - DISCLOSURE</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            We may disclose your personal information if we are required by
            law to do so or if you violate our Terms of Service.
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>SECTION 4 - PAYMENT</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            We use Razorpay for processing payments. We/Razorpay do not
            store your card data on their servers. The data is encrypted
            through the Payment Card Industry Data Security Standard
            (PCI-DSS) when processing payment. Your purchase transaction
            data is only used as long as is necessary to complete your
            purchase transaction. After that is complete, your purchase
            transaction information is not saved.
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            Our payment gateway adheres to the standards set by PCI-DSS as
            managed by the PCI Security Standards Council, which is a joint
            effort of brands like Visa, MasterCard, American Express and
            Discover.
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            PCI-DSS requirements help ensure the secure handling of credit
            card information by our store and its service providers.
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>SECTION 5 - THIRD-PARTY SERVICE</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            In general, the third-party providers used by us will only
            collect, use and disclose your information to the extent
            necessary to allow them to perform the services they provide to
            us.
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            However, certain third-party service providers, such as payment
            gateways and other payment transaction processors, have their
            own privacy policies in respect to the information we are
            required to provide to them for your purchase-related
            transactions.
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            For these providers, we recommend that you read their privacy
            policies so you can understand the manner in which your personal
            information will be handled by these providers.
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            In particular, remember that certain providers may be located in
            or have facilities that are located a different jurisdiction
            than either you or us. So if you elect to proceed with a
            transaction that involves the services of a third-party service
            provider, then your information may become subject to the laws
            of the jurisdiction(s) in which that service provider or its
            facilities are located.
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            Once you leave our website or are redirected to a third-party
            website or application, you are no longer governed by this
            Privacy Policy or our website's Terms of Service.
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>Links</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            When you click on links on our website, they may direct you away
            from our site. We are not responsible for the privacy practices
            of other sites and encourage you to read their privacy
            statements.
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>SECTION 6 - SECURITY</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            To protect your personal information, we take reasonable
            precautions and follow industry best practices to make sure it
            is not inappropriately lost, misused, accessed, disclosed,
            altered or destroyed.
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>SECTION 7 –SESSION COOKIES</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            We use Session cookies to maintain session of user. It is not
            used to personally identify you on other websites. Session
            cookies are deleted when you leave our website. They help keep
            track of your progress so that you don't have to enter the same
            information more than once.
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>SECTION 8 - AGE OF CONSENT</p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            By using this site, you represent that you are at least the age
            of majority in your state or province of residence, or that you
            are the age of majority in your state or province of residence
            and you have given us your consent to allow any of your minor
            dependents to use this site.
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>
            SECTION 9 - CHANGES TO THIS PRIVACY POLICY
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            We reserve the right to modify this privacy policy at any time,
            so please review it frequently. Changes and clarifications will
            take effect immediately upon their posting on the website. If we
            make material changes to this policy, we will notify you here
            that it has been updated, so that you are aware of what
            information we collect, how we use it, and under what
            circumstances, if any, we use and/or disclose it.
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            If our website is acquired or merged with another company, your
            information may be transferred to the new owners so that we may
            continue to sell products to you.
          </p>
          <p className="mission_subheading" style={{ textAlign: "left", color: "#50288c", fontWeight: "700", marginBottom: "15px", marginTop: "20px" }}>
            QUESTIONS AND CONTACT INFORMATION
          </p>
          <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582", marginBottom: "15px" }}>
            If you would like to: access, correct, amend or delete any
            personal information we have about you, register a complaint, or
            simply want more information contact our Privacy Compliance
            Officer at hello@heartfultech.com or by mail at HEARTFUL TECH
            PVT LTD, H No.13-14, 2nd floor, Kothnur Main Rd, Opposite
            Corporation Bank, JP Nagar 7th Phase, Bengaluru, Karnataka -
            560078.
          </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;




